interface TrendyEmptyStateProps {
  onCreateClick: () => void;
}

export function TrendyEmptyState({ onCreateClick }: TrendyEmptyStateProps) {
  return (
    <div className="pt-[26px] pb-6 px-4">
      {/* Card Container - Taller for better balance */}
      <div className="relative w-full h-[280px] bg-white dark:bg-[#0f2217] rounded-lg overflow-hidden border border-black/10 dark:border-transparent">
        {/* Header Text - Real HTML */}
        <div className="relative z-20 pt-4 px-6 text-center">
          <h3 className="font-dm-sans font-semibold text-[15.73px] leading-[131%] text-slate-900 dark:text-white">
            No challenges yet
          </h3>
          <p className="font-dm-sans font-semibold text-[15.73px] leading-[131%] text-slate-900 dark:text-white mt-1">
            Be <span className="text-primary-dark dark:text-[#21f219]">the one</span> who starts the
            movement !
          </p>
        </div>

        {/* Gradient Bar - CSS gradient (stationary behind runners) */}
        <div
          className="absolute left-0 right-0 h-[33px] z-0 gradient-bar"
          style={{
            top: "110px",
          }}
        />

        {/* Runners Illustration - 3 people running (moved up) */}
        <div
          className="absolute left-1/2 -translate-x-1/2 z-10"
          style={{
            top: "40px",
            width: "206px",
            height: "158px",
            background: "transparent"
          }}
        >
          <img
            src="/runners.png"
            alt="Three runners"
            className="w-full h-full object-contain"
            style={{
              filter: "drop-shadow(0px 4px 36.1px rgba(0, 0, 0, 0.23))",
              border: "none",
              outline: "none",
              background: "transparent",
              display: "block",
            }}
          />
        </div>

        {/* Runners Shadow - Darker and positioned under their feet (moved up) */}
        <div
          className="absolute left-1/2 -translate-x-1/2 z-5"
          style={{ top: "160px", width: "176px", height: "5px" }}
        >
          <div
            className="w-full h-full"
            style={{
              background: "#000000",
              mixBlendMode: "multiply",
              borderRadius: "50%",
              filter: "blur(1px)",
            }}
          />
        </div>

        {/* CTA Button - Create button inside card with gap from shadow */}
        <button
          onClick={onCreateClick}
          className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 px-6 py-2 bg-primary-dark dark:bg-primary border border-black/10 dark:border-white/12 rounded-full text-white dark:text-black text-[10px] font-dm-sans font-semibold hover:brightness-110 transition-all active:scale-[0.98] cursor-pointer"
        >
          Create the first Challenge!
        </button>
      </div>
    </div>
  );
}
